const EventBus = window.VueEventBus

import ComponentMixin from '../../../../mixins/components/complex'
export const mixins = [ComponentMixin]

export default {
  name: 're-form-field',
  mixins,
  props: {
    settings: {},
    translations: {},
    value: {},
    field: {
      type: [Object],
      default() {
        return {}
      }
    },
    form: {
      type: [Object],
      default() {
        return {}
      }
    },
    customErrors: {},
    validations: {
      type: [Object],
      default() {
        return {}
      }
    },
    v: {},
    vRoot: {},
    $$v: {},
    classes: {},
  },
  model: {
      prop: 'value',
      event: 'update'
  },
  validations: null,
  data() {
    return {
      //fieldValue: this.$$fv(this.value, this.field.value, this.field.default)
      //fieldValue: this.value
    }
  },

  watch: {
    value(val) {
      this.fieldValue = val
    }
  },

  computed: {
    fieldValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('update', val)
      }
    },
    '$v': function() {
      return this.$$v
    },
    component() {
      const defaultComponent = 're-input'
      const type = this.field.type || 'input'
      let component = this.field.component || type
      const reComponent = _.startsWith(component, 're-') ? component : 're-' + component
      let probedComponent = this.probeComponent(reComponent)
      if (probedComponent) {
        return probedComponent
      }
      probedComponent = this.probeComponent(component)
      if (probedComponent) {
        return probedComponent
      }
      component = 're-' + type
      return this.probeComponent(component, defaultComponent)
    },
    isVisible() {
      return this.field.show !== false
    },
    isDisabled() {
        return this.field.disabled === true
    },
    fieldName() {
      return this.field.name
    },
    attr() {
      const field = this.field
      const omitFromField = ['type', 'reactive', 'value', 'hidden']
      let attr = {...(field.attr || {}), ..._.omit(field, omitFromField)}
      if (field.hidden) {
        attr.type = 'hidden'
      }
      if (this.customErrors) {
        attr.customErrors = this.customErrors
      }
      return attr
    }
  },
  created() {

  },
  methods: {
    handleInput(...values) {
      this.fieldValue = values[0]
      this.resetFieldValidation()
      //this.$emit('update', ...values)
    },
    resetFieldValidation(fieldsPath = 'fields') {
      const fieldName = this.fieldName
      const pathPrefix = (fieldsPath ? `${fieldsPath}.` : '') + fieldName
      const reset  = _.get(this.$$v, pathPrefix + '.$reset', (() => {}))
      reset()
      // this.setCustomError(fieldName, [])
    },
    getFieldProps() {
      let props = {
        ...this.attr,
        validations: this.validations,
        v: this.v,
        vRoot: this.vRoot,
      }
      return props
    },
    getComponentExtraClasses() {
      const fieldType = _.get(this.attr, 'type', _.get(this.field, 'type', ''))
      return [
        this.field.class || [],
        `field-type-${fieldType}`,
        {
          disabled: this.isDisabled,
        }
      ]
    },
    reset() {

    },
    show() {

    },
    hide() {

    }
  },
}
